import React from 'react'
import { useOffline } from '../hooks/useOffline'

const OfflineIndicator: React.FC = () => {
  const { isOffline, cacheStats, formatCacheSize } = useOffline()

  if (!isOffline) {
    return null
  }

  return (
    <div className="offline-indicator" role="alert" aria-live="polite">
      <div className="offline-indicator-content">
        <div className="offline-indicator-icon">📡</div>
        <div className="offline-indicator-text">
          <div className="offline-indicator-title">Offline Mode</div>
          <div className="offline-indicator-subtitle">
            {cacheStats.totalSounds > 0
              ? `${cacheStats.totalSounds} sounds available offline`
              : 'No sounds cached for offline use'
            }
          </div>
          {cacheStats.totalSize > 0 && (
            <div className="offline-indicator-cache-size">
              Cache size: {formatCacheSize(cacheStats.totalSize)}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default OfflineIndicator
